<template>
  <div class='report-item report-item--expanding-stat brand-background-color'>
    <div class="text">
      <div class='actions' v-if='editable && !this.content.stat'>
        <h2 class='editHeading' @click.prevent='onEdit'>Add a headline statistic <ion-icon name="add-circle-outline"></ion-icon></h2>
      </div>
      <div class='stats-header' v-if='content.stat' :style='headingStyles'>
        <div class='stats-expander'>
          <div class="stats">
            <Stat @change='refreshStat($event)' ref='statItem' :translated='translatedStatText' :config='content.stat' @edit='onEditStat($event)' :circle='false' v-if='content.stat' :theme='theme' @delete='deleteStat' :editable='editable' :data='report.stats'></Stat>
            <div class='expander' v-if='content.stat && content.expandable' :style='expanderStyle' @click.prevent='toggleExpand'>
              <ion-icon name='remove' :style='expanderIconStyle' v-if='content.expanded'></ion-icon>
              <ion-icon name='add'  :style='expanderIconStyle' v-if='!content.expanded'></ion-icon>
            </div>
          </div>
        </div>
      </div>
      <transition name='fade' mode='out-in'>
        <div :key='expanderID' class='expanded' :id='expanderID' v-show='config.expanded && currentReport'>
          <div :class="breakdownClasses" v-if='currentReport'>
            <QuestionBreakdown ref='questionBreakdown' @change='onBreakdownChange' :translation-context='`${tag}.questionbreakdown`' @edit='onEditBreakdown($event)' :editable='editable' :circle='true' :config='config.breakdown' :data='currentReport'></QuestionBreakdown>
          </div>
        </div>
      </transition>
    </div>
    <div v-if='editable'>
      <UIActions @add='onAdd' @delete='onDelete' @edit='onEditMain'></UIActions>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import UIActions from './UIActions.vue'
import ContentEditable from '../../ContentEditable.vue'
import _ from 'lodash';
import Stat from './Stat'
import QuestionBreakdown from './QuestionBreakdown'
import StatEditor from '../../report-editor/components/StatEditor'
import Button from './Button.vue'
import TranslationMixin from '../lib/TranslationMixin'
import Utilities from '../../lib/Utilities.js'

export default {
  props: {
    config: {default: ()=>{{}}, type: Object},
    report: {default: ()=>({}), type: Object},
    response: {type: Object, default: ()=>{{}}},
    editable: {default: true, type: Boolean}
  },
  mixins: [TranslationMixin],
  data () {
    return {
      content: {},
      ready: false,
      newStat: null,
      currentReport: null,
      reports: null,
      stat: null,
      expanderID: null
    }
  },
  inject: ['globalTheme'],
  components: {
    UIActions,
    ContentEditable,
    StatEditor,
    Stat,
    QuestionBreakdown,
    Button
  },
  methods: {
    refreshStat(event) {
      if (typeof event === 'undefined') {
        return
      }
      if (event) {
        this.content.stat = event
      } else {
        this.content.stat = this.config.stat
      }
      this.currentReport = this.reports[this.config.stat.question]
    },
    onBreakdownChange (value) {

    },
    onEditStat (event) {
      this.$emit('edit', event)
    },
    toggleExpand () {
      this.content.expanded = !this.content.expanded
      if(this.content.expanded){
        Vue.nextTick(() => {
          let expanderElement = document.getElementById(this.expanderID);
          let y = expanderElement.offsetTop
          window.scrollTo({left:0, top: y, behavior: 'smooth'})
        })
      }
    },
    onEdit () {
      Vue.nextTick(()=>{
        this.$emit('edit', {target: this.$refs.statItem, fields: null, editorClass: 'StatEditPanel'})
      })
    },
    onEditMain () {
      this.$emit('edit', {target: this, fields: null, editorClass: 'HeadlineStatisticEditPanel'})
    },
    onCTAEdit (event) {
      this.$emit('edit', event)
    },
    onAdd () {
      this.$emit('add')
    },
    onDelete () {
      this.$emit('delete')
    },
    onEditBreakdown (event) {
      this.$emit('edit', event)
    },
    addStat (event) {
      if (this.content.stat) {
        this.content.stat.valueText = event.valueText
        this.content.stat.text = event.text
        this.stat = this.content.stat
      } else {
        this.content.stat = event
        this.stat = this.content.stat
      }
      this.currentReport = this.reports[event.question]
      this.$refs.statItem.reload()
    },
    deleteStat (event) {
      let conf = confirm("Deletion is permanent. Are you sure?")
      if(conf){
        this.content.stat = null
        this.content.expanded = false
        this.currentReport = null
      } else {
        return
      }
    },
    updateReports (event) {
      let questions
      if (!this.response) {
        questions = this.report.questions
      } else {
        questions = this.report.stats
      }
      let reports = {}
      for (let key in questions){
        let question = questions[key]
        const storedSchema = this.report.questionSchema
        const questionIndex = Utilities.getIndexOfObject(storedSchema, 'key', key)
        const questionSchema = storedSchema[questionIndex]
        const questionType = questionSchema.type

        reports[key] = {questionKey: key, question: this.report.questions[key], stats: this.report.stats[key], answers: this.report.answers[key]}
        if(this.response && this.config.stat && this.config.stat.question) {
          let pc
          let answer = this.response.answers[key]
          if (answer === null || typeof answer === 'undefined' || answer === '') {
            pc = 0.0
          } else if (Array.isArray(answer)) {
            let totalPcs = 0
            for (let selection of answer) {
              let aResult = this.report.stats[key][selection]
              totalPcs += aResult.percent
            }
            pc = totalPcs / answer.length
            if (isNaN(pc)) {
              pc = 0
            }
          } else {
            pc = this.report.stats[key][answer].percent
          }

          let responseStat = {
              answer: answer,
              pc: pc,
              type: questionType
            }
          Object.assign(reports[key], responseStat)
        }
      }
      this.reports = reports;
      this.currentReport = this.reports[this.config.stat.question]
    }
  },
  computed: {
    expanderStyle () {
      return {
        backgroundColor: this.config.breakdown.theme.backgroundColor
      }
    },
    expanderIconStyle () {
      return {
        color: this.config.breakdown.theme.titleColor
      }
    },
    translatedStatText () {
      return this.$t(this.config.stat.text, "stat.text", this.tag)
    },
    theme () {
      let themeOptions = {
        statColor: this.config.theme.statFigureColor
      }
      return {
        ...themeOptions,
        ...this.config.theme
      }
    },
    headingStyles () {
      return {
        backgroundColor: this.computedStatBackgroundColor,
        backgroundImage: "url(" +this.config.image+ ")",
        backgroundPosition: this.backgroundPosition,
        backgroundSize: 'cover'
      }
    },
    backgroundPosition () {
      const x = 50
      const y = this.config.theme.backgroundVertical || 50
      return `${x}% ${y}%`
    },
    detailStyles () {
      return {
        color: this.theme.detailHeadingColor
      }
    },
    breakdownClasses () {
      let classes = ['question-breakdown-wrapper']
      if(this.config.showCommentary === true){
        classes.push('has-commentary')
      }
      return classes;
    },
    questionBreakdownTheme () {
      return {
        color: this.theme.detailHeadingColor,
        circleColor: this.theme.circleColor
      }
    },
    computedStatBackgroundColor () {
      let campaignBackgroundColor = this.globalTheme.campaign ? this.globalTheme.campaign.secondary.backgroundColor : null
      return this.config.theme.statBackgroundColor || campaignBackgroundColor
    },
    computedCommentTitleFontSize () {
      return this.config.theme.commentTitleFontSize || this.globalTheme.titleFontSize
    },
    computedCommentTextFontSize () {
      return this.config.theme.commentTextFontSize || this.globalTheme.textFontSize
    },
    computedCommentTextColor () {
      return this.config.theme.commentTextColor || this.globalTheme.brandTextColor
    },
    computedCommentTitleColor () {
      return this.config.theme.commentTitleColor || this.globalTheme.brandTitleColor
    },
    computedCommentBackgroundColor () {
      return this.config.theme.commentBackgroundColor || this.globalTheme.chartSelectionColor
    }
  },
  created () {
    this.content = this.config
    this.expanderID = 'expander-' + this._uid;
    this.updateReports()
    this.save = _.debounce(function(){
      if (!this.editable) {
        return
      }
      this.$store.dispatch('saveItem', this.config)
    }, 500)
    this.$watch('config.stat', this.updateReports, {deep: true})
  },
  watch: {
    config: {
      handler: function (config) {
        this.refreshStat()
      },
      deep: true
    },
    content: {
      handler: function(content){
        if (!this.ready){
          this.ready = true
          return
        }
        this.$store.commit('setDirty', true)
        this.save()
      },
      deep: true
    }
  }
}
</script>
<style lang='scss' scoped>
  @import '../../../../scss/components/variables';
  @import '../scss/transitions';
  @import '../../../../scss/components/form';

  .actions {
    display: flex;
    min-height: 200px;
    align-items: center;
    justify-content: center;
  }
  .editHeading {
    text-align: center;
    color: #ccc;
    width: 50%;
    cursor: pointer;
    font-size: 200%;
    ion-icon {
      vertical-align: -5px;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: all .5s linear;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
      overflow: hidden;
      max-height: 0;
  }

  .fade-enter-to, .fade-leave {
    max-height: 500px;
   overflow: hidden;
  }

  .simple-form {
    .extended-info {
      ::v-deep .content-editable--input[contenteditable='true'] {
        border-bottom: 2px dashed rgba(0,0,0,0.4);
      }
    }
  }
  .report-item--expanding-stat {
    background-size: cover;
    min-height: 150px;
    //height: 20vh;
    .stats-expander {
      width: 90%;
      margin:auto;
      padding: 0.75rem 0 40px 0;
      position: relative;
      .stats {
        padding: 0;
        @media (min-width: 768px){
          //padding: 0 1rem;
        }
      }
      @media(min-width: 768px) {
        width: 80%;
        padding: 0.75rem 0 80px 0;
      }
    }
    .extended-info {
      margin:2rem  auto;
      width: 90%;
      @media (min-width: 758px){
        width: 80%;
        margin: 3rem auto;
      }
    }
    .commentary-header {
      margin-bottom: 2rem;
      background-color: #fbd147;
      padding: 1rem 1rem;
      border-radius: 10px;
      ::v-deep h2.content-editable--input {
        margin-bottom: 0;
        //font-size: 130%;
      }
      @media (min-width: 768px) {
        padding: 1.3rem 2rem;
        ::v-deep h2.content-editable--input {
          //font-size: 160%;
        }
      }
    }
    .stats {
      padding: 0 1rem;
      .stat + .stat {
        border-top: 2px solid #000;
      }
      @media (min-width: 768px) {
        margin-top: 1rem;
        padding: 0.75rem 1rem 0.25rem 1rem;
      }
    }
    .actions {
      width: 80%;
      margin: 2rem auto;
    }

    .expander {
      display: flex;
      cursor: pointer;
      position: absolute;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      bottom: 0;
      left:0;
      right: 0;
      width: 75px;
      height: 40px;
      margin: auto;
      text-align:center;
      background-color: white;
      border-radius: 100px 100px 0 0;
      ion-icon {
        margin-top: 6px;
        color: black;
        font-size: 25px;
      }
      @media (min-width: 768px){
        width: 150px;
        height: 75px;
        border-radius: 150px 150px 0 0;
        ion-icon {
          margin-top: 10px;
          font-size: 45px;
        }
      }
    }
    ::v-deep .stat {
      @media (min-width: 920px){
        padding: 4rem 0;
      }
      .figure {
        @media (min-width: 768px) {
          .figure-content {
            h2 {
              //font-size: 10vw;
            }
          }
        }
        @media (min-width: 1000px) {
          .figure-content {
            h2 {
              //font-size: 8vw;
            }
          }
        }
        @media (min-width: 1200px) {
          .figure-content {
            h2 {
              //font-size: 8vw;
            }
          }
        }
        @media (min-width: 1300px) {
          .figure-content {
            h2 {
              //font-size: 6rem;
            }
          }
        }
      }
      .caption {
        text-align: center;
        @media (min-width: 768px) {
          text-align: left;
        }
        @media (min-width: 768px){
          padding-left: 2rem;
        }
        font-size: 150%;
        line-height: 1.3;
        font-size: 100%;
        @media (min-width: 768px) {
          //font-size: 300%;
        }
      }
      .ui-actions {
        top: 30px;
      }
    }

    ::v-deep .stat.without-value {
      .caption {
        @media (min-width: 768px){
          padding-left: 0rem;
        }
      }
    }

    ::v-deep .question-breakdown-wrapper {
      padding: 0 0 ;
      &.has-commentary {
        padding-bottom: 0;
      }
      .bars {
        margin-bottom:0;
        padding-bottom: 0;
      }
      .question {
        margin-bottom: 0;
        & + .question {
          margin-top: 2rem;
        }
      }
    }
    .question-breakdown {
      width: 100%;
      ::v-deep .question-breakdown--content {
        width: 90%;
        margin: auto;
        padding: 5% 0;
      }

      ::v-deep hr {
        //margin-bottom: 1rem;
      }
      @media (min-width: 758px){
        ::v-deep .question-breakdown--content {
          width: 80%;
        }
      }
      margin:auto;
    }
    @media(min-width: 768px) {
      //min-height: 300px;
      // height: 30vh;
    }
    @media(min-width: 920px) {
      //min-height: 400px;
      // height: 45vh;
    }
    .text {
      display: flex;
      height:100%;
      justify-content: center;
      flex-direction: column;
      width: 100%;
      margin:auto;
      h1 {
        margin-bottom: 0.1rem;
      }
      h2 {
        margin-top: 0;
      }
    }
  }
</style>